import Ripple from "public/svgs/ripple.svg";

export const LoadingRipple = () => {
  return (
    <div className="flex justify-center">
      <Ripple width={175} height={175} />
    </div>
  );
};

export const LoadingRippleFullscreen = () => {
  return (
    <div
      className="relative z-30"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full  items-center justify-center p-4 text-center sm:p-0 ">
          <div className="relative my-8  max-w-lg transform overflow-hidden rounded-lg bg-transparent bg-white text-left transition-all">
            <Ripple width={175} height={175} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingRipple;
